import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "./logo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [show, setShow] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      // SHOW / HIDE NAVBAR

      if (currentY > lastScrollY && currentY > 80) {
        setShow(false);
      } else {
        setShow(true);
      }

      // ADD SCROLL CLASS

      if (currentY > 40) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      setLastScrollY(currentY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  return (
    <>
      <nav
        className={`navbar ${scrolled ? "scrolled" : ""} ${
          show ? "show" : "hide"
        }`}
      >
        {/* LOGO SECTION */}

        {/* <div className="logo-box">
          <a href="/home" className="logo">
            <img src="/images/logo1.jpeg" alt="logo" className="logo-img" />

            <span>
              શ્રી વૈભવલક્ષ્મી મહિલા કો-ઓ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર
              સોસાયટી લિ.
            </span>
            <p>રજી. નં. સા. 3228/1999 તા.5/10/99</p>
          </a>
        </div> */}

        <div className="logo-box">
          <a href="/home" className="logo">
            <img src="/images/logo1.jpeg" alt="logo" className="logo-img" />

            <div className="logo-content">
              <span>
                શ્રી વૈભવલક્ષ્મી મહિલા કો-ઓ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર
                સોસાયટી લિ.
              </span>

              <p className="reg-number">રજી. નં. સા. ૩૨૨૮/૧૯૯૯ તા. ૫/૧0/૯૯</p>
            </div>
          </a>
        </div>

        {/* MENU SECTION */}

        <div className="menu-wrapper">
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? "✕" : "☰"}
          </div>

          <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
            <li>
              <NavLink
                to="/home"
                className="nav-link"
                onClick={() => setMenuOpen(false)}
              >
                હોમ
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/about"
                className="nav-link"
                onClick={() => setMenuOpen(false)}
              >
                અમારા વિશે
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/gallery"
                className="nav-link"
                onClick={() => setMenuOpen(false)}
              >
                પ્રવૃત્તિઓ
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/join"
                className="nav-link"
                onClick={() => setMenuOpen(false)}
              >
                સંપર્ક કરો
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
